function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React, { Component } from 'react';
import classNames from 'classnames';
import { Dialog } from '@kuaizhan/kui';
import PropTypes from 'prop-types';
import shareImg from './images/1.png';
import './style.less';

var InviteModal = /*#__PURE__*/function (_Component) {
  _inherits(InviteModal, _Component);

  var _super = _createSuper(InviteModal);

  function InviteModal(props) {
    var _this;

    _classCallCheck(this, InviteModal);

    _this = _super.call(this, props);
    _this.handleShareWeibo = _this.handleShareWeibo.bind(_assertThisInitialized(_this));
    _this.handleShareQQZone = _this.handleShareQQZone.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InviteModal, [{
    key: "handleShareWeibo",
    value: function handleShareWeibo() {
      console.log('share weibo', this);
      var baseUrl = 'http://service.weibo.com/share/share.php?';
      var params = [// 'appkey=3874358783',
      'title=分享测试', 'url=https://www.sohu.com', "pic=".concat(shareImg), 'source=', 'sourceUrl=' // 'ralateUid=3066179133',
      ];
      var paramsString = params.join('&');
      var shareUrl = "".concat(baseUrl).concat(paramsString);
      window.open(shareUrl);
    }
  }, {
    key: "handleShareQQZone",
    value: function handleShareQQZone() {
      console.log('share QQZone', this);
      var baseUrl = 'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?';
      var params = ['title=分享测试', 'url=https://www.kuaizhan.com', 'pics=https://kzcdn.itc.cn/res/homepage/images/shop/section-4-3.png', 'summary=testtetsttest'];
      var paramsString = params.join('&');
      var shareUrl = "".concat(baseUrl).concat(paramsString);
      window.open(shareUrl);
    }
  }, {
    key: "render",
    value: function render() {
      var clsPrefix = 'c-invite-modal';
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          hide = _this$props.hide,
          onClose = _this$props.onClose,
          inviteCode = _this$props.inviteCode;
      console.log(inviteCode);
      var cls = classNames(clsPrefix, className);
      return /*#__PURE__*/React.createElement(Dialog, {
        hide: hide,
        style: style,
        className: cls,
        hasClose: true,
        onClose: onClose,
        portal: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--pic")
      }, /*#__PURE__*/React.createElement("img", {
        src: shareImg,
        alt: "\u5206\u4EAB"
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--content")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--title")
      }, "\u751F\u6210\u4E13\u5C5E\u9080\u8BF7\u6D77\u62A5"), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--desc")
      }, "\u2014\u83B7\u5F9710%\u8FD4\u73B0\u540C\u65F6\u5E26\u7ED9\u5BF9\u65B99\u6298\u4F18\u60E0\u2014"), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--qrcode")
      }, /*#__PURE__*/React.createElement("img", {
        className: "".concat(clsPrefix, "--img"),
        src: "",
        alt: "\u4E8C\u7EF4\u7801"
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--qrtxt")
      }, "\u626B\u7801\u5206\u4EAB")), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--share")
      }, /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: 0,
        className: "".concat(clsPrefix, "--cell"),
        onClick: this.handleShareWeibo
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--icon ").concat(clsPrefix, "--weibo")
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--name")
      }, "\u5FAE\u535A")), /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: 0,
        className: "".concat(clsPrefix, "--cell"),
        onClick: this.handleShareQQZone
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--icon ").concat(clsPrefix, "--qqzone")
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--name")
      }, "QQ\u7A7A\u95F4")), /*#__PURE__*/React.createElement("a", {
        href: shareImg,
        download: "\u6211\u7684\u9080\u8BF7\u7801",
        className: "".concat(clsPrefix, "--cell")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--icon ").concat(clsPrefix, "--local")
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--name")
      }, "\u672C\u5730\u4FDD\u5B58")))), /*#__PURE__*/React.createElement("a", {
        className: "".concat(clsPrefix, "--rule"),
        href: "sssssss"
      }, '邀请码规则详情>>'));
    }
  }]);

  return InviteModal;
}(Component);

InviteModal.defaultProps = {
  className: '',
  style: {},
  hide: true,
  onClose: function onClose() {},
  inviteCode: ''
};
InviteModal.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  hide: PropTypes.bool,
  onClose: PropTypes.func,
  inviteCode: PropTypes.string
};
export default InviteModal;